import { createApi } from '@reduxjs/toolkit/query/react';
import { DataTags } from './dataTags';

export const api = createApi({
    endpoints: () => ({}),
    tagTypes: Object.values(DataTags),
});
